export default {
  title: 'Acuerdo',
  description: 'Se le cobrará {{amount}} al mes si no cancela su prueba.',
  bill_at_launch_date: 'Primera factura en la fecha de lanzamiento',
  bill_date: 'Fecha de factura: {{date}}',
  bill_date_after_launch: 'Primera factura: {{days}} días tras el lanzamiento',
  sign_agreement: 'Por favor, firme el acuerdo de suscripción y participación del restaurante',
  restaurant: 'Restaurante',
  agreement:
    'Acepto los <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">términos de la plataforma</a>. Puedo cancelar la suscripción en cualquier momento notificando a {{provider}} de la cancelación. La suscripción se cancelará y el acuerdo de pago se revocará en cuanto el Restaurante contacte a {{provider}} por correo electrónico o WhatsApp. No se realizarán más cargos al restaurante a partir de entonces. Acepto que mi consentimiento electrónico equivale a firmar este documento y entiendo que mi firma electrónica es vinculante.',
};
